module.exports = __webpack_public_path__ + "static/faceit-wall-9d33f52df73567f494a979b37bdb0f08.png";